/*
  Project: Life Insurance Canada
  Author: xfive
 */

import './modules/focus-outline';
import './modules/searched';
import './modules/navigation';
import './modules/anchor-nav';
import './modules/compare-insurance-dropdown';
// import './modules/testimonials';
// import './modules/images-carousel';
import './modules/carousels';
import './modules/accordion';
import './modules/ebook';
import './modules/misc';
import ImagesShapes from './modules/images-shapes';
import './modules/select2';
import './modules/tooltip';
import './modules/blog';
import './modules/show-all';

const imagesShapes = new ImagesShapes();
imagesShapes.init();



// WEBPACK FOOTER //
// ./src/scripts/app.js